import { useTranslation } from 'react-i18next';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

import useGetSupplierUsage from '@/queries/analytics/useGetSuppliersUsage';
import { getColor } from '@/utils/colors';

import Container from '../components/Container';
import { TotalsBarChartCurrencyTooltip } from '../components/CustomTooltip';
import Loader from '../components/Loader';

import styles from './SupplierUsageBarChart.module.scss';

const defaultFrom: string = new Date(new Date().getDate() - 7).toISOString();
const defaultTo: string = new Date().toISOString();

type SupplierUsageBarChartProps = { from?: string; to?: string };

const SupplierUsageBarChart = ({
  from = defaultFrom,
  to = defaultTo,
}: SupplierUsageBarChartProps) => {
  const { t } = useTranslation();
  const { data: result } = useGetSupplierUsage(from, to);

  if (!result) {
    return <Loader />;
  }

  const data = result.map((res) => ({
    ...res,
    fill: getColor(res.name),
    label: res.name,
  }));

  if (!data.length) {
    return (
      <Container className={styles.emptyState}>
        <span className={styles.message}>{t('commons.emptyResult')}</span>
      </Container>
    );
  }

  return (
    <Container className={styles.container}>
      <h5 className={styles.legend}>{t('widgets.supplierTotal')}</h5>
      <ResponsiveContainer
        width="100%"
        height={145}
        className={styles.responsiveContainer}
      >
        <BarChart data={data} maxBarSize={20}>
          <XAxis dataKey="name" />
          <Tooltip cursor={false} content={<TotalsBarChartCurrencyTooltip />} />
          <Bar dataKey="total" />
        </BarChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default SupplierUsageBarChart;
